// extracted by mini-css-extract-plugin
module.exports = {"Button":"B_rr w_rr w_rd g_ds g_dH g_dw g_gh","full":"B_sm g_cq g_cB","width100":"B_cq g_cq","design3Pos":"B_sn g_cV"};